module.exports = __webpack_public_path__ + "static/media/answer_cn.fab5bc73.png";